<template>
  <div class="dealer-info">
    <div class="dealer-container">
      <p>
        고객님은 LG유플러스 본사가 보증하는 온라인판매 인증대리점을 통해
        단말기를 구입 및 이동통신서비스에 가입됩니다.
      </p>
      <ul>
        <li>
          <dl>
            <dt>가입대리점명 :</dt>
            <dd>
              <span class="dynamic-data-temp">{{
                $store.state.openMarketInfo.agentName
              }}</span>
            </dd>
            <dt>주소 :</dt>
            <dd>
              <span class="dynamic-data-temp">{{
                $store.state.openMarketInfo.agentAddress
              }}</span>
            </dd>
            <dt>전화번호 :</dt>
            <dd>
              <span class="dynamic-data-temp">{{
                $store.state.openMarketInfo.agentTelNo
              }}</span>
            </dd>
          </dl>
        </li>

        <li>
          <dl>
            <dt>판매점명 :</dt>
            <dd>
              <span class="dynamic-data-temp">{{
                $store.state.openMarketInfo.sellerName
              }}</span>
            </dd>
            <dt>주소 :</dt>
            <dd>
              <span class="dynamic-data-temp">{{
                $store.state.openMarketInfo.sellerAddress
              }}</span>
            </dd>
            <dt>전화번호 :</dt>
            <dd>
              <span class="dynamic-data-temp">{{
                $store.state.openMarketInfo.sellerTelNo
              }}</span>
            </dd>
            <dt>사업자등록번호 :</dt>
            <dd>
              <span class="dynamic-data-temp">{{
                $store.state.openMarketInfo.sellerRegistrationNo
              }}</span>
            </dd>
          </dl>
        </li>
      </ul>
      <p>
        통신서비스의 속도 및 커버리지 정보는 홈페이지(www.lguplus.com) 에서
        확인할 수 있습니다.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DealerInfo',
  data() {
    return {
      agentId: '',
      result: {}
    }
  },
  beforeMount() {},
  mounted() {},

  methods: {}
}
</script>

<style scoped></style>
